export default {"src":"/_next/static/media/library-big.6f273036.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};